module.exports = __webpack_public_path__ + "img/info.755a0ab6.svg";